module.exports = __webpack_public_path__ + "img/store_hbqcgyxy.f9b47450.jpg";